import type { IconType } from "react-icons";
import {
  FiAlertCircle,
  FiBarChart2,
  FiBell,
  FiBriefcase,
  FiCalendar,
  FiCheckSquare,
  FiTrendingUp,
  FiUserPlus,
  FiUsers,
  FiVideo,
  FiMail,
  FiXCircle,
} from "react-icons/fi";

export const ADMIN_NAV_ITEMS = [
  { key: "events", labelKey: "sidebar.adminEvents", Icon: FiCalendar },
  { key: "meetings", labelKey: "sidebar.adminMeetings", Icon: FiVideo },
  { key: "welcomeEmails", labelKey: "sidebar.adminWelcomeEmails", Icon: FiMail },
  { key: "users", labelKey: "sidebar.adminUsers", Icon: FiUsers },
  { key: "earlyStage", labelKey: "sidebar.adminEarlyStage", Icon: FiCheckSquare },
  {
    key: "notificationPanel",
    labelKey: "sidebar.adminNotificationPanel",
    Icon: FiBell,
  },
  { key: "parteners", labelKey: "sidebar.adminPartners", Icon: FiUserPlus },
  {
    key: "invest-company",
    labelKey: "sidebar.adminInvestCompany",
    Icon: FiBriefcase,
  },
  { key: "investors", labelKey: "sidebar.adminInvestors", Icon: FiTrendingUp },
  { key: "reports", labelKey: "sidebar.adminReports", Icon: FiBarChart2 },
  {
    key: "payment-errors",
    labelKey: "sidebar.adminPaymentErrors",
    Icon: FiAlertCircle,
  },
  {
    key: "cancellations",
    labelKey: "sidebar.adminCancellations",
    Icon: FiXCircle,
  },
] as const satisfies ReadonlyArray<{
  key: string;
  labelKey: string;
  Icon: IconType;
}>;

export type AdminNavKey = (typeof ADMIN_NAV_ITEMS)[number]["key"];
